import * as React from 'react'
import { useTranslation } from 'react-i18next'

interface CopyJSONButtonProps {
  jsonData: object
  buttonTitle?: string
  jsonName: string
}

export const CopyJSONButton: React.FC<CopyJSONButtonProps> = ({ jsonData, buttonTitle, jsonName }) => {
  const { t } = useTranslation()
  const jsonString = JSON.stringify(jsonData, null, 2)
  const blob = new Blob([jsonString], { type: 'application/json' })
  const blobURL = URL.createObjectURL(blob)

  return (
    <a href={blobURL} download={jsonName}>
      <strong> {buttonTitle ?? t('copyJsonButton.defaultTitle')}</strong>
    </a>
  )
}
